export default __webpack_public_path__ + "static/media/cal_bg5.2edf71b2.jpg";